import { Settings, ViewerBoardInfo } from '@gorilla/widgets-viewer/app/viewer/types';
import { DEFAULT_SETTINGS } from '@gorilla/widgets-shared/src/services/publish';

export function findFirstFieldWithType(boardInfo: ViewerBoardInfo, types: string[]) {
  for (const type of types) {
    const fields = boardInfo.fields.filter((field) => field.type === type);

    if (!fields.length) {
      continue;
    }

    return fields[0].id;
  }

  return null;
}

export function getDefaultSettings(boardInfo: ViewerBoardInfo) {
  const settings: Settings = {
    ...DEFAULT_SETTINGS,
    gridItemImageColumn: findFirstFieldWithType(boardInfo, ['file']),
    gridItemHeadlineColumn: 'name',

    eventsItemImageColumn: findFirstFieldWithType(boardInfo, ['file']),
    eventsItemHeadlineColumn: 'name',
    eventsItemDateColumn: findFirstFieldWithType(boardInfo, ['date']),
    eventsItemLocationColumn: findFirstFieldWithType(boardInfo, ['location']),
    eventsItemDescriptionColumn: findFirstFieldWithType(boardInfo, ['long_text', 'text']),
    eventsItemLearnMoreColumn: findFirstFieldWithType(boardInfo, ['link']),
  };

  return settings;
}
